import React from 'react';
import { motion } from 'framer-motion';
const CART_URL = 'https://guiaspracticas.myshopify.com//cart/add?id=51259935031586&quantity=1';
export function ProductIntroSection() {
  const handleCtaClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'The F-Formula',
        content_type: 'product',
        value: 18.9,
        currency: 'USD'
      });
    }
  };
  return <section className="py-32 bg-primary relative overflow-hidden" data-id="element-147">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-148" />

      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center text-center relative z-10" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-150">
          <h2 className="text-5xl md:text-7xl font-black text-gold tracking-wider mb-4" data-id="element-151">
            THE F-FORMULA
          </h2>
          <p className="text-xl md:text-2xl text-white/80 font-light mb-12 max-w-2xl mx-auto" data-id="element-152">
            El sistema de 3 fases para generar atracción real sin manipular.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-12 w-full max-w-2xl" data-id="element-153">
          <img src="https://cdn.magicpatterns.com/uploads/dUCumyGdRDtNLM4eLMGY7t/Generated_Image_February_11,_2026_-_11_47PM.jpg" alt="The F-Formula Product Mockup" className="w-full h-auto rounded-lg shadow-2xl border border-white/5" data-id="element-154" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-155">
          <p className="text-lg text-gray-300 mb-6 leading-relaxed" data-id="element-156">
            Un sistema estructurado, basado en psicología emocional, diseñado
            para hombres que quieren resultados reales sin convertirse en
            alguien que no son.
          </p>

          {/* Pricing */}
          

          <a href={CART_URL} onClick={handleCtaClick} target="_blank" rel="noopener noreferrer" className="inline-block bg-gold hover:bg-gold-light text-primary font-bold text-lg py-4 px-12 rounded-sm transition-all duration-300 transform hover:scale-[1.02] shadow-[0_0_20px_rgba(201,168,76,0.3)]" data-id="element-157">
            Quiero acceder ahora
          </a>
        </motion.div>
      </div>
    </section>;
}